import { createSlice } from '@reduxjs/toolkit';

export interface VisaPageManagement {
    pageSectionName: 'Agreement' | 'Documents' | '';
}

const initialState: VisaPageManagement = {
    pageSectionName: '',
};

export const visaPageManageSlice = createSlice({
    name: 'visaPageManage',
    initialState,
    reducers: {
        changePage: (state, action) => {
            state.pageSectionName = action.payload;
        },
    },
});
